// DS1.7.14
import React from 'react';
import c from 'classnames';
import s from './BetaBadge.scss';

interface BaseProps {
  badgeType: 'beta' | 'new' | 'soon' | 'custom';
  size: 'small' | 'medium';
  variant: 'green' | 'purple' | 'theme';
  className?: string;
  children?: React.ReactNode;
}

interface PropsWithCustomBadgeType extends BaseProps {
  badgeType: 'custom';
  children: React.ReactNode;
}

export type Props = BaseProps | PropsWithCustomBadgeType;

const BetaBadge: React.FC<Props> = ({ badgeType, size, variant, className, children }) => {
  return (
    <div
      className={c(
        className,
        s['root'],
        s[`size-${size}`],
        s[`variant-${variant}`],
        badgeType === 'custom' && s['is-custom-type']
      )}
    >
      {badgeType === 'beta' && 'BETA'}
      {badgeType === 'new' && 'NEW!'}
      {badgeType === 'custom' && children}
    </div>
  );
};
BetaBadge.displayName = 'BetaBadge';

export default BetaBadge;
